import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import { RendererContextProvider } from '@turiya/orchestrator-renderer-react';
import { LoadingScreen } from "./view/pages/LoadingScreen";
import "./app.css";

const Homescreen = lazy(() =>
  import('./view/pages/home').then((m) => ({ default: m.Homescreen }))
);


function App() {
  return (
    <RendererContextProvider>
      <SnackbarProvider maxSnack={5} autoHideDuration={3000}>
        <BrowserRouter>
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route exact path="/auth" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
              <Route path="/" element={<Homescreen />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </SnackbarProvider>
    </RendererContextProvider>
  );
}

export default App;
